import React from 'react';
import {SwitchMain} from "components";
import {RoutersInfo} from "root";
import {ExportCsv} from "fragments";
import {pendingTripsCsv} from "../constants";
import {useModal} from "utils";
import {Svg} from "assets";


export const MainHeader = ({pathname, control}) => {
    const {openModal} = useModal();

    const currentPage = RoutersInfo()?.find((rout) =>
        pathname?.startsWith(rout?.path),
    );

    const handleExportCSV = () => {
        openModal(
            <ExportCsv params={pendingTripsCsv}/>, {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 610,
            })
    }

    return (
        <div className="main-info-fragment-header">
            <p className="main-info-fragment-header-title">{currentPage?.name}</p>

            <div className="main-info-fragment-header-right-side">
                <SwitchMain
                    label='Map View'
                    name='mapView'
                    control={control}
                    labelPlacement='right'
                />

                <button
                    className='main-info-fragment-header-btn'
                    type='button'
                    onClick={handleExportCSV}
                >
                    <Svg.ExportCSVSvg/>
                    Export CSV
                </button>
            </div>
        </div>
    );
};

